import * as React from "react"
import { Fragment } from "react"
import { useTranslate } from "ra-core"
import {
    BulkDeleteWithConfirmButton,
    DatagridConfigurable,
    List,
    //SearchInput,
    TopToolbar,
    CreateButton,
    FilterButton,
    SelectColumnsButton,
    CloneButton,
    ExportButton,
    TextField,
    ReferenceField,
    ReferenceInput,
    TextInput,
    DateField,
    EditButton,
    WrapperField,
    ShowButton,
    BulkExportButton,
    usePermissions,
    AutocompleteInput,
} from "react-admin"
import * as buttons from "components/ui/buttons"
import { ReferenceArrayFieldShowLink } from "components/ui/layouts"

const getDeviceFilters = (permissions: string): React.ReactElement[] => {
    const filters = [
        <TextInput source="imei" />,
        <ReferenceInput source="device_kind_id" reference="device-kinds" />,
        <ReferenceInput 
            source="equipment_ids"
            reference="equipments"
            filterToQuery={(searchText: string) => ({ name: searchText })}
        >
            <AutocompleteInput 
                optionText="name"
            />
        </ReferenceInput>,
    ]
    if (permissions === "admin") {
        filters.push(<TextInput source="role" />)
    }
    return filters
}


const ListActions = () => (
    <TopToolbar>
        <CreateButton />
        <FilterButton />
        <SelectColumnsButton />
        <ExportButton />
    </TopToolbar>
)
const PostBulkActionButtons = () => (
    <Fragment>
        <BulkExportButton />
        <BulkDeleteWithConfirmButton mutationMode="optimistic"/>
    </Fragment>
)


const DeviceList = () => {
    const { permissions } = usePermissions()
    const translate = useTranslate()

    return (
        <List
            filters={getDeviceFilters(permissions)}
            //filterDefaultValues={{ role: "Device" }}
            sort={{ field: "created_at", order: "DESC" }}
            actions={<ListActions />}
        >
            <DatagridConfigurable sx={{
                "& .RaDatagrid-headerCell": { 
                    fontWeight: 'bold' 
                }
            }} bulkActionButtons={<PostBulkActionButtons/>}>
                <ReferenceField label={translate("resources.devices.fields.imei")} source="id" reference="devices">
                    <TextField source="imei" label={translate("resources.devices.fields.imei")} />
                </ReferenceField>
                <ReferenceField label={translate("resources.devices.fields.device_kind_id")} source="device_kind_id" reference="device-kinds">
                    <TextField source="name" />
                </ReferenceField>
                <ReferenceArrayFieldShowLink source="equipment_ids" reference="equipments" />
                
                <ReferenceField label={translate("resources.devices.fields.object_id")} source="object_id" reference="objects" />
                <ReferenceField label={translate("resources.devices.fields.energy_kind_id")} source="energy_kind_id" reference="energy-kinds">
                    <TextField source="name" />
                </ReferenceField>
                <DateField showTime source="created_at" label={translate("resources.common.fields.created_at")}></DateField>
                <WrapperField label={translate("internal.actions")}>
                    <ShowButton label="" title={translate("ra.action.show")} />
                    <EditButton label="" title={translate("ra.action.edit")}/>
                    <CloneButton label="" title={translate("ra.action.clone")}/>
                    <buttons.DeleteWithConfirmButtonX title={translate("ra.action.remove")} field="name" />
                </WrapperField>
            </DatagridConfigurable>
        </List>
    )
}

export default DeviceList